import Staking from "./Staking.json";
import Token from "./Token.json";

export const stakingABI = Staking.abi;
export const stakingAddress = "0x948491d3f710adb870ee44545f1a57e6521188ce";
export const tokenABI = Token.abi;
export const tokenAddress = "0x569EB2A0f04A7134788d7c02b6B804D9B1d82D09";
